import { memo } from 'react';
import logoutIcon from '@/public/images/icons/dashboard/logout.svg';
import Image from 'next/image';
import stylesConstants from '@/constants/styles.constants';
import uiItems from '@/constants/ui-items/index.constants';
import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
const MenuLogoutLink = () => {
  const { t } = useTranslation('index');
  return (
    // eslint-disable-next-line @next/next/no-html-link-for-pages
    <a
      href="/auth/logout"
      className={stylesConstants.header.menuLinks.defaultLiClass}
    >
      <div className={stylesConstants.header.menuLinks.mainSectionClass}>
        <Image
          src={logoutIcon}
          width={24}
          height={24}
          alt={translationFallback(
            uiItems.header.menuLinks.logout.tKey,
            t(uiItems.header.menuLinks.logout.tKey),
            uiItems.header.menuLinks.logout.tFallback
          )}
          className="me-2"
        />
        <div className="tw-w-full">
          <span>
            {translationFallback(
              uiItems.header.menuLinks.logout.tKey,
              t(uiItems.header.menuLinks.logout.tKey),
              uiItems.header.menuLinks.logout.tFallback
            )}
          </span>
        </div>
      </div>
    </a>
  );
};

const SettingsLogoutLink = () => {
  return (
    // eslint-disable-next-line @next/next/no-html-link-for-pages
    <a
      href="/auth/logout"
      className="d-flex justify-content-start align-items-center"
    >
      <Image src={logoutIcon} width={24} height={24} alt="Buy" />
    </a>
  );
};

const SettingsMemoLogoutLink = memo(SettingsLogoutLink);

const MenuMemoLogoutLink = memo(MenuLogoutLink);

export { SettingsMemoLogoutLink, MenuMemoLogoutLink };
